var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"theme4-home"},[_c('theme4-home-card'),_c('theme4-section1',{attrs:{"id":"theme4-section1"}}),_c('theme4-section2'),_c('theme-changer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }